export default __webpack_public_path__ + "static/media/ESTJ.9f30d978.svg";